import { render } from "./Footer.vue?vue&type=template&id=97e5440e&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=97e5440e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ivan\\Desktop\\PROJECTS\\econom.landing-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97e5440e"]])

export default __exports__